import toNumber from 'lodash/toNumber'
import React from 'react'
import { NumberInput, RadioInput } from '@ztechapps/webui.input'
import { Row, Table } from '@ztechapps/webui.data-tools'
import { HorizontalStack } from '@ztechapps/webui.util'
import { useCheckoutContext } from '../../index'

export const ManualShippingRate = () => {
  const context = useCheckoutContext()
  const [shippingOptions, setShippingOptions] = context.shippingOptions
  const isManualShippingRate = shippingOptions.isManualShippingRate
  const shippingFee = shippingOptions.shippingFee

  return (
    <>
      <hr />

      <Table
        dataArray={[{ shippingFee: shippingFee, isManualShippingRate: true, hasSelected: isManualShippingRate }]}
        row={ManualShippingRateRow}
        onSelect={() => {
          setShippingOptions({
            isManualShippingRate: true,
            carrierRate: null,
            shippingBillTo: { isBillToCustomer: false },
          })
        }}
        className={'table-sm'}
      />
    </>
  )
}

const ManualShippingRateRow = ({ ...props }) => {
  const context = useCheckoutContext()
  const [shippingOptions, setShippingOptions] = context.shippingOptions
  const isManualShippingRate = shippingOptions.isManualShippingRate
  const shippingFee = shippingOptions.shippingFee

  const manualShippingFee = isManualShippingRate ? shippingFee : 0
  return (
    <Row {...props}>
      <td style={{ width: '80%' }}>
        <HorizontalStack gap={3}>
          <RadioInput name="custom_shipping_rate" checked={isManualShippingRate} readOnly />
          <div>
            <h4>Custom shipping rate.</h4>
            <div>
              <p>
                You will handle the shipping for this order externally. No courier and shipment information will be
                provided, you will print the shipping label from external software and track also the progress there.
                <br />
                For accounting purposes, you can set here the (manual) shipping fee for this order.
              </p>
            </div>
          </div>
        </HorizontalStack>
      </td>
      <td>
        <NumberInput
          min={0}
          value={manualShippingFee}
          onChange={(e) => {
            const fee = toNumber(e?.target?.value)
            setShippingOptions({ shippingFee: fee, isManualShippingRate: true, carrierRate: null })
          }}
        />
      </td>
    </Row>
  )
}
